import {
    PRICING_GET_INITIAL_DATA,
    PRICING_GET_INITIAL_DATA_SUCCESS
} from './actionTypes';

export function fetchInitialData(token) {
    return {
        type: PRICING_GET_INITIAL_DATA,
        token
    }
}

export function getInitialDataSuccess(data) {
    return {
        type: PRICING_GET_INITIAL_DATA_SUCCESS,
        data
    }
}